import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { documentApprovalColumns } from "../../tables/documentApprovalColumns";
import AdminDataTable from "../../components/common/AdminDataTable";
import PoliceVerificationPopup from "./PoliceVerificationPopup";
import ViewPhotoPopup from "./ViewPhotoPopup";
import toast from "../../utils/toast";
import { can } from "../../utils/can";

export default function ProfileDocumentApproval() {
  const PAGE_SIZE = 10;

  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [policeFile, setPoliceFile] = useState(null);
  const [fileError, setFileError] = useState(null);

  const [member, setMember] = useState([]);

  // filters
  const [name, setName] = useState("");
  const [emailMobile, setEmailMobile] = useState("");
  const [profileId, setProfileId] = useState("");

  const token = localStorage.getItem("adminToken");
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  const fetchMember = async (overrides = {}) => {
    setListLoading(true);

    const {
      page: pageOverride,
      limit: limitOverride,
      sortBy: sortByOverride,
      sortOrder: sortOrderOverride,
      name: nameOverride,
      emailMobile: emailMobileOverride,
      profileId: profileIdOverride,
    } = overrides;

    try {
      const queryParams = new URLSearchParams({
        page: pageOverride ?? page,
        limit: limitOverride ?? pageSize,
        sortBy: sortByOverride ?? sortBy,
        sortOrder: sortOrderOverride ?? sortOrder,
        name: nameOverride ?? name,
        emailMobile: emailMobileOverride ?? emailMobile,
        profile_id: profileIdOverride ?? profileId,
      }).toString();

      const response = await fetch(
        `${API_URL}/api/admin/profile-management/get-profile-document?${queryParams}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.success) {
        setMember(result.data || []);

        const totalPagesCalc = Math.ceil(
          (result.totalCount || 0) / (pageSize || PAGE_SIZE)
        );

        setTotalPages(totalPagesCalc || 1);
      } else {
        setMember([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.log("Error fetching members:", error);
    } finally {
      setListLoading(false);
    }
  };

  const memberApproval = async (userId, verifyType, status) => {
    try {

      const response = await fetch(
        `${API_URL}/api/admin/profile-management/request-approval`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            user_id: userId,
            verifyType: verifyType,
            status,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        fetchMember();
      } else {
        console.log(result.message);
      }

    } catch (error) {
      console.log("Approval Error:", error);
    } finally {
      setListLoading(false);
    }
  };

  const handleUpload = async () => {
  if (!policeFile) {
    setFileError("Please select file");
    return;
  }

  if (!selectedRow?._id) {
    setFileError("Invalid user");
    return;
  }

  const formData = new FormData();
  formData.append("policeDocument", policeFile);
  formData.append("userId", selectedRow._id);

  try {

    const res = await fetch(
      `${API_URL}/api/admin/upload-police-verification`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || "Upload failed");
    }

    if (data.success) {
      setFileError("Uploaded Successfully");

      setMember((prev) =>
        prev.map((item) =>
          item._id === selectedRow._id
            ? {
                ...item,
                policeApproval: "Pending",
                policeDocument: data.fileUrl,
              }
            : item
        )
      );

      setShowModal(false);
      setPoliceFile(null);
    }
  } catch (error) {
    console.log("Upload error:", error);
    setFileError(error.message || "Upload failed");
  }
};




  useEffect(() => {
    if(can("document_approval", "view") === false){
      window.location.href = "/admin/dashboard";
      toast.showError("You don't have permission to view document approval.");  
      return;
    }
    fetchMember();
  }, [page, pageSize, sortBy, sortOrder]);

  const openModal = (row) => {
    setSelectedRow({ ...row });
    setShowModal(true);
  };

  const handleFileChange = (e) => {
    setPoliceFile(e.target.files[0]);
  };

  const clearFilters = () => {
    setName("");
    setEmailMobile("");
    setProfileId("");
    setPage(1);
    fetchMember({ page: 1, profileId: "", name: "", emailMobile: "" });
  };

  const columns = documentApprovalColumns({ PAGE_SIZE, handleApproval: memberApproval, openModal, API_URL });

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Document Approval" />

        {/* page content */}
        <div className="right_col" role="main">
         

          <div className="x_panel">
            <div className="x_title">
              <h2>Document Approval</h2>
              <div className="clearfix" />
            </div>

            <div className="x_content">
              {/* FILTER */}
              <div className="filtercont">
                <div className="row">
                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-sm-4">
                        <label>Profile ID</label>
                        <input
                          type="text"
                          className="form-control"
                          value={profileId}
                          onChange={(e) => setProfileId(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-4">
                        <label>Search By Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-4">
                        <label>Email / Mobile</label>
                        <input
                          type="text"
                          className="form-control"
                          value={emailMobile}
                          onChange={(e) => setEmailMobile(e.target.value)}
                        />
                      </div>

                      
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="col-12 d-flex align-items-end" style={{ "marginTop": 25}}>
                      
                      <button
                        className="btn-small btn-default submit sitebtn px-3 mr-2"
                        onClick={() => {
                          if (page !== 1) {
                            setPage(1);
                          } else {
                            fetchMember({ page: 1 });
                          }
                        }}
                      >
                        Submit
                      </button>
                      <button
                        className="btn-small btn-secondary sitebtn  px-3"
                        onClick={clearFilters}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* TABLE */}
              <AdminDataTable
                columns={columns}
                data={member}
                page={page}
                pageSize={pageSize}
                totalPages={totalPages}
                loading={listLoading}
                onPageChange={setPage}
                onPageSizeChange={(size) => {
                  setPageSize(size);
                  setPage(1);
                  fetchMember({ page: 1, limit: size });
                }}
                sortBy={sortBy}
                sortOrder={sortOrder}
              />

              <PoliceVerificationPopup
                showModal={showModal}
                selectedRow={selectedRow}
                handleFileChange={handleFileChange}
                handleUpload={handleUpload}
                setShowModal={setShowModal}
                error={fileError}
              />
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
